module.exports = __webpack_public_path__ + "img/donutes.aa952356.svg";